import * as React from 'react'

import Stack from '@mui/material/Stack'

import ResponsiveContainer from 'components/atomic/organisms/responsive-container'
import ResumeContent from 'pages/course/resume-content'
import PathProgress from 'pages/course/progress'
import Syllabus from 'pages/course/syllabus'

import { Track } from 'types/types'

const ContentEnrolled = ({ course }: { course: Track }) => {
    return (
        <ResponsiveContainer maxWidth="lg">
            <Stack mt="3rem" spacing="3rem">
                <ResumeContent courseId={course._id} />
                <PathProgress courseId={course._id} />
                <Syllabus course={course} />
            </Stack>
        </ResponsiveContainer>
    )
}

export default ContentEnrolled
